// Вызов API с типами из контракта (app/openapi.json → src/types/openapi.d.ts, п.19).
// Конверт ответа: {ok:true, data} | {ok:false, error:{code, message}}.
import type { paths } from './types/openapi';

export type ApiError = { code: string; message: string };
export type Result<T> = { ok: true; data: T } | { ok: false; error: ApiError };

type Json200<T> = T extends { responses: { 200: { content: { 'application/json': { data: infer D } } } } }
  ? D : never;
type Method = 'get' | 'post' | 'patch' | 'put' | 'delete';
/** Тип поля data ответа ручки: Data<'/api/projects/{pid}/spiski', 'get'> */
export type Data<P extends keyof paths, M extends Method & keyof paths[P]> = Json200<paths[P][M]>;
type Body<T> = T extends { requestBody: { content: { 'application/json': infer B } } } ? B : never;
/** Тип тела запроса: Req<'/api/projects/{pid}/spiski', 'post'> */
export type Req<P extends keyof paths, M extends Method & keyof paths[P]> = Body<paths[P][M]>;

function token(): string | null {
  try { return localStorage.getItem('plot_t'); } catch { return null; }
}

/** Заголовок входа для запросов мимо call(): загрузка чертежа (FormData) и чтение файла (#104). */
export function authHdr(): Record<string, string> {
  const t = token();
  return t ? { Authorization: 'Bearer ' + t } : {};
}

export async function call<T = unknown>(method: Method, path: string, body?: unknown): Promise<Result<T>> {
  const t = token();
  const r = await fetch(path, {
    method: method.toUpperCase(),
    headers: { 'Content-Type': 'application/json', ...(t ? { Authorization: 'Bearer ' + t } : {}) },
    body: body === undefined ? undefined : JSON.stringify(body),
  });
  try {
    return (await r.json()) as Result<T>;
  } catch {
    return { ok: false, error: { code: 'bad_response', message: 'Сервер ответил не JSON (' + r.status + ')' } };
  }
}

/** Подстановка {pid} и прочих параметров пути */
export function p(path: string, params: Record<string, string | number>): string {
  return path.replace(/\{(\w+)\}/g, (_, k) => encodeURIComponent(String(params[k])));
}
